import { render, staticRenderFns } from "./addDatum.vue?vue&type=template&id=30729070&scoped=true"
import script from "./addDatum.vue?vue&type=script&lang=js"
export * from "./addDatum.vue?vue&type=script&lang=js"
import style0 from "./addDatum.vue?vue&type=style&index=0&id=30729070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30729070",
  null
  
)

export default component.exports